<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Add Manager</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <form>
          <div class="panel panel-grey">
            <div class="panel-body">
              <div class="form-horizontal">

                <create-user ref="createUser"/>

                <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.company" :field-name="$options.filters.sentenceCase($t('organisation'))"/>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <field-input :model="$v.position" field-name="Job Title"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <ladda-button
                class="btn btn-sm btn-primary"
                type="submit"
                :click="handleAddManagerCallback">
                Add Manager
              </ladda-button>

              <div class="checkbox checkbox-primary pull-right" v-if="$vlastMode && $userIsAdmin">
                <input
                  type="checkbox"
                  name="send_activation_email"
                  id="send_activation_email"
                  v-model="$v.send_activation_email.$model"
                  />

                <label for="send_activation_email">
                  Send Activation Email To Manager
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { notify, http } from 'utils'
import CreateUser from '../CreateUser'
import FieldInput from '../misc/FieldInput'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    CreateUser,
    FieldInput
  },

  data () {
    return {
      company: null,
      position: null,
      send_activation_email: false
    }
  },

  validations: {
    company: { required },
    position: {},
    send_activation_email: {}
  },

  methods: {
    handleAddManagerCallback () {
      if (this.$refs.createUser.invalid || this.$v.$invalid) {
        this.$v.$touch()
        this.$refs.createUser.validate()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }

      const payload = {
        ...this.$refs.createUser.payload,
        company: this.company,
        position: this.position,
        send_activation_email: this.send_activation_email
      }

      return http.post(`managers`, payload)
        .then((response) => {
          this.$router.push({ name: 'managers.profile.show', params: { id: response.data.id } })
        })
        .catch(() => {
          notify.error('Something went wrong. Please check your input and try again.')
        })
    }
  }
}
</script>
